// Utility to test CORS and API connectivity

export const corsTest = {
  testRegisterStudent: async () => {
    try {
      console.log('Testing register-student API connection...');
      const response = await fetch('/api/register-student/', {
        method: 'OPTIONS',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      console.log('CORS preflight response:', response);
      console.log('CORS headers:', {
        'Access-Control-Allow-Origin': response.headers.get('Access-Control-Allow-Origin'),
        'Access-Control-Allow-Methods': response.headers.get('Access-Control-Allow-Methods'),
        'Access-Control-Allow-Headers': response.headers.get('Access-Control-Allow-Headers')
      });
      
      return response.ok;
    } catch (error) {
      console.error('CORS test failed:', error);
      return false;
    }
  },
  
  // Test multiple possible API endpoints
  testAllEndpoints: async () => {
    const endpoints = [
      '/api/register-student/',
      '/api/register-student',
      '/api/register/',
      '/api/register',
      '/api/users/register/',
      '/api/users/register',
      '/api/auth/register/',
      '/api/auth/register'
    ];
    
    console.log('Testing multiple possible API endpoints...');
    const results = {};
    
    for (const endpoint of endpoints) {
      try {
        console.log(`Testing endpoint: ${endpoint}`);
        const response = await fetch(endpoint, {
          method: 'OPTIONS'
        });
        results[endpoint] = {
          status: response.status,
          ok: response.ok
        };
        console.log(`Endpoint ${endpoint} response:`, response.status, response.ok);
      } catch (error) {
        results[endpoint] = {
          error: error.message
        };
        console.error(`Endpoint ${endpoint} error:`, error);
      }
    }
    
    console.log('Endpoint test results:', results);
    return results;
  },
  
  // Direct test with payload
  testEndpoint: async (endpoint, payload) => {
    try {
      const url = `/api/${endpoint}`;
      console.log(`Testing direct API call to ${url}`, payload);
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      let data;
      try {
        data = await response.json();
      } catch (e) {
        const text = await response.text();
        console.log('Response not JSON:', text);
        data = { text };
      }
      
      console.log(`Endpoint ${url} response:`, {
        status: response.status,
        ok: response.ok,
        data
      });
      
      return {
        status: response.status,
        ok: response.ok,
        data
      };
    } catch (error) {
      console.error(`Direct test failed:`, error);
      return {
        error: error.message
      };
    }
  }
};

// Make the utility available in the global window object for console testing
if (typeof window !== 'undefined') {
  window.corsTest = corsTest;
} 